import Vue from 'vue'
import Router from 'vue-router'
import loadcomponents from '@/tools/loadcomponents'
import getLocal from '@/common/cookie'
const routes = [
  {
    path: '/login',
    name: 'login',
    component: loadcomponents.load('login', 'views', ''),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: loadcomponents.load('login/register', 'views', ''),
    meta: {
      title: '注册'
    }
  },
  {
    path: '/',
    name: 'home',
    component: loadcomponents.load('home', 'views', ''),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/resources',
    name: 'resources',
    component: loadcomponents.load('resources', 'views', ''),
    meta: {
      title: '资源'
    }
  },
  {
    path: '/home',
    name: 'home',
    component: loadcomponents.load('home', 'views', ''),
    meta: {
      title: '首页'
    }
  }, {
    path: '/home1',
    name: 'home',
    component: loadcomponents.load('formwork1', 'views', '/home'),
    meta: {
      title: '首页'
    }
  }, {
    path: '/aboutacademy',
    name: 'aboutacademy',
    component: loadcomponents.load('aboutacademy', 'views', ''),
    meta: {
      title: '帮助中心'
    },
    children: [
      {
        path: '/leader',
        name: 'leader',
        component: loadcomponents.load('leader', 'views', '/aboutacademy'),
        meta: {
          title: '学会章程'
        }
      }, {
        path: '/contentlist',
        name: 'contentlist',
        component: loadcomponents.load('contentlist', 'views', '/aboutacademy'),
        meta: {
          title: '学会规章'
        }
      }, {
        path: '/contentdetail',
        name: 'contentdetail',
        component: loadcomponents.load('contentdetail', 'views', '/aboutacademy'),
        meta: {
          title: '规章详情'
        }
      }
    ]
  }, {
    path: '/learndynamics',
    name: 'learndynamics',
    component: loadcomponents.load('learndynamics', 'views', ''),
    meta: {
      title: '新闻公告'
    }
  }, {
    path: '/course',
    name: 'course',
    component: loadcomponents.load('course', 'views', ''),
    meta: {
      title: '课程'
    }
  }, {
    path: '/newcourse',
    name: 'newcourse',
    component: loadcomponents.load('studycenter/newcourse', 'views', ''),
    meta: {
      title: '课程'
    }
  }, {
    path: '/lecturer',
    name: 'lecturer',
    component: loadcomponents.load('lecturer', 'views', ''),
    meta: {
      title: '授课专家'
    }
  }, {
    path: '/popularcourse',
    name: 'popularcourse',
    component: loadcomponents.load('course/popularcourse', 'views', ''),
    meta: {
      title: '热门课程'
    }
  }, {
    path: '/train',
    name: 'train',
    component: loadcomponents.load('course/train', 'views', ''),
    meta: {
      title: '课程中心'
    }
  }, {
    path: '/order',
    name: 'order',
    component: loadcomponents.load('course/order', 'views', ''),
    meta: {
      title: '订单详情'
    }
  }, {
    path: '/workersevaluation',
    name: 'workersevaluation',
    component: loadcomponents.load('workersevaluation', 'views', ''),
    meta: {
      title: '职业评价'
    }
  }, {
    path: '/learnresearch',
    name: 'learnresearch',
    component: loadcomponents.load('learnresearch', 'views', ''),
    meta: {
      title: '学术研究'
    }
  }, {
    path: '/workerstandard',
    name: 'workerstandard',
    component: loadcomponents.load('workerstandard', 'views', ''),
    meta: {
      title: '社工标准'
    }
  }, {
    path: '/statutepolicy',
    name: 'statutepolicy',
    component: loadcomponents.load('statutepolicy', 'views', ''),
    meta: {
      title: '法规政策'
    }
  }, {
    path: '/special',
    name: 'special',
    component: loadcomponents.load('special', 'views', ''),
    meta: {
      title: '专题'
    }
  }, {
    path: '/speciallistsecond',
    name: 'speciallistsecond',
    component: loadcomponents.load('special/speciallistsecond', 'views', ''),
    meta: {
      title: '专题二级列表'
    }
  }, {
    path: '/speciallistthird',
    name: 'speciallistthird',
    component: loadcomponents.load('special/speciallistthird', 'views', ''),
    meta: {
      title: '专题三级列表'
    }
  }, {
    path: '/specialdetail',
    name: 'specialdetail',
    component: loadcomponents.load('special/specialdetail', 'views', ''),
    meta: {
      title: '专题详情'
    }
  },
  {
    path: '/secondlist',
    name: 'secondlist',
    component: loadcomponents.load('secondlist', 'views', ''),
    meta: {
      title: '新闻公告列表'
    }
  }, {
    path: '/contentmaindetail',
    name: 'contentmaindetail',
    component: loadcomponents.load('contentmaindetail', 'views', ''),
    meta: {
      title: '详情页'
    }
  },
  {
    path: '/authregister',
    name: 'authregister',
    component: loadcomponents.load('auth/register', 'views', ''),
    meta: {
      title: '会员注册'
    }
  },
  {
    path: '/registerdetail',
    name: 'registerdetail',
    component: loadcomponents.load('auth/register/detail', 'views', ''),
    meta: {
      title: '会员详情页'
    }
  },
  {
    path: '/generalregister',
    name: 'generalregister',
    component: loadcomponents.load('auth/generalregister', 'views', ''),
    meta: {
      title: '普通用户注册'
    }
  },
  {
    path: '/sitesearch',
    name: 'sitesearch',
    component: loadcomponents.load('sitesearch', 'views', ''),
    meta: {
      title: '全文搜索'
    }
  },
  {
    path: '/mine',
    name: 'mine',
    component: loadcomponents.load('mine', 'views', ''),
    meta: {
      // 个人中心过程统计
      title: '过程统计'
    }
  },
  {
    path: '/process',
    name: 'process',
    component: loadcomponents.load('process', 'views', '/mine'),
    meta: {
      // 个人中心过程统计
      title: '过程统计'
    }
  },
  {
    path: '/trainRecord',
    name: 'trainRecord',
    component: loadcomponents.load('trainRecord', 'views', '/mine'),
    meta: {
      // 个人中心训练记录
      title: '训练记录'
    }
  },
  {
    path: '/accountManagement',
    name: 'accountManagement',
    component: loadcomponents.load('mine/accountManagement', 'views', ''),
    meta: {
      // 个人中心帐号管理
      title: '帐号管理'
    }
  },
  {
    path: '/myExamTask',
    name: 'myExamTask',
    component: loadcomponents.load('examTask', 'views', '/mine'),
    meta: {
      // 个人中心考试任务
      title: '考试任务'
    }
  },
  {
    path: '/collection',
    name: 'collection',
    component: loadcomponents.load('mine/collection', 'views', ''),
    meta: {
      // 个人中心我的收藏
      title: '我的收藏'
    }
  },
  {
    path: '/myCourseClass',
    name: 'myCourseClass',
    component: loadcomponents.load('myCourseClass', 'views', '/mine'),
    meta: {
      // 个人中心我的收藏
      title: '我的课程'
    }
  },
  {
    path: '/errorSet',
    name: 'errorSet',
    component: loadcomponents.load('errorSet', 'views', '/mine'),
    meta: {
      // 个人中心错题集
      title: '错题集'
    }
  },
  {
    path: '/personalcenter',
    name: 'personalcenter',
    component: loadcomponents.load('personalcenter', 'views', ''),
    meta: {
      title: '个人中心'
    },
    children: [
      {
        path: '/information',
        name: 'information',
        component: loadcomponents.load('information', 'views', '/personalcenter'),
        meta: {
          title: '基本信息'
        }
      }, {
        path: '/permeeting',
        name: 'permeeting',
        component: loadcomponents.load('permeeting', 'views', '/personalcenter'),
        meta: {
          title: '会议/报名管理'
        }
      }, {
        path: '/personaltopic',
        name: 'personaltopic',
        component: loadcomponents.load('personaltopic', 'views', '/personalcenter'),
        meta: {
          title: '课题管理'
        }
      }
    ]
  },
  {
    path: '/editpass',
    name: 'editpass',
    component: loadcomponents.load('auth/generalregister/editpass', 'views', ''),
    meta: {
      title: '修改密码'
    }
  },
  {
    path: '/declaredtopic',
    name: 'declaredtopic',
    component: loadcomponents.load('declaredtopic', 'views', ''),
    meta: {
      title: '申请课题'
    }
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: loadcomponents.load('auth/forgotpassword', 'views', ''),
    meta: {
      title: '找回密码'
    }
  },
  {
    path: '/declared',
    name: 'declared',
    component: loadcomponents.load('declaredtopic/declared', 'views', ''),
    meta: {
      title: '申报课题'
    }
  },
  {
    path: '/studycenter',
    name: 'studycenter',
    component: loadcomponents.load('studycenter', 'views', ''),
    meta: {
      title: '学习中心'
    }
  }, {
    path: '/coursedetail',
    name: 'coursedetail',
    component: loadcomponents.load('studycenter/coursedetail', 'views', ''),
    meta: {
      title: '学习详情'
    }
  },
  {
    path: '/continue',
    name: 'continue',
    component: loadcomponents.load('studycenter/coursedetail/continue', 'views', ''),
    meta: {
      title: '继续学习'
    }
  },
  {
    path: '/starttrain',
    name: 'traincase',
    component: loadcomponents.load('studycenter/traincase/starttrain', 'views', ''),
    meta: {
      title: '开始学习'
    }
  },
  {
    path: '/startStudy',
    name: 'continue',
    component: loadcomponents.load('studycenter/coursedetail/start_study', 'views', ''),
    meta: {
      title: '开始学习'
    }
  },
  {
    path: '/enterexam',
    name: 'enterexam',
    component: loadcomponents.load('studycenter/exam/enterexam', 'views', ''),
    meta: {
      title: '进入考试'
    }
  },
  {
    path: '/startexam',
    name: 'startexam',
    component: loadcomponents.load('studycenter/exam/startexam', 'views', ''),
    meta: {
      title: '开始考试'
    }
  },
  {
    path: '/viewscore',
    name: 'viewscore',
    component: loadcomponents.load('studycenter/exam/viewscore', 'views', ''),
    meta: {
      title: '查看成绩'
    }
  },
  {
    path: '/privatecenter',
    name: 'privatecenter',
    component: loadcomponents.load('privatecenter', 'views', ''),
    meta: {
      title: '个人中心'
    }
  },
  {
    path: '/mistakes',
    name: 'mistakes',
    component: loadcomponents.load('privatecenter/mistakes', 'views', ''),
    meta: {
      title: '错题集'
    }
  },
  {
    path: '/mistakesdetail',
    name: 'mistakesdetail',
    component: loadcomponents.load('privatecenter/mistakes/mistakesdetail', 'views', ''),
    meta: {
      title: '错题详情'
    }
  },
  {
    path: '/declareddetail',
    name: 'declareddetail',
    component: loadcomponents.load('declaredtopic/declareddetail', 'views', ''),
    meta: {
      title: '课题内容详情'
    }
  },
  {
    path: '/subscriber',
    name: 'subscriber',
    component: loadcomponents.load('subscriber', 'views', ''),
    meta: {
      title: '预览首页'
    }
  },
  {
    path: '/traincase',
    name: '学习实训',
    component: loadcomponents.load('studycenter/traincase', 'views', ''),
    meta: {
      title: '学习实训'
    }
  },
  {
    path: '/subscriberCoursedetail',
    name: 'subscriber_coursedetail',
    component: loadcomponents.load('subscriber/coursedetail', 'views', ''),
    meta: {
      title: '预览课程'
    }
  },
  {
    path: '/subscriberContinue',
    name: 'subscriber_coursedetail_continue',
    component: loadcomponents.load('subscriber/coursedetail/continue', 'views', ''),
    meta: {
      title: '预览课程'
    }
  },
  {
    path: '/subscriberStartStudy',
    name: 'subscriber_coursedetail_start_study',
    component: loadcomponents.load('subscriber/coursedetail/start_study', 'views', ''),
    meta: {
      title: '预览课程'
    }
  },
  {
    path: '/enroll',
    name: 'enroll',
    component: loadcomponents.load('enroll', 'views', '/studycenter'),
    meta: {
      title: '报名'
    }
  },
  {
    path: '/enrollUser',
    name: 'enrollUser',
    component: loadcomponents.load('studycenter/enroll/enrollUser', 'views', ''),
    meta: {
      title: '填写信息'
    }
  },
  {
    path: '/pay',
    name: 'pay',
    component: loadcomponents.load('studycenter/enroll/pay', 'views', ''),
    meta: {
      title: '支付'
    }
  },
  {
    path: '/enrollUserInfo',
    name: 'enrollUserInfo',
    component: loadcomponents.load('studycenter/enroll/enrollUserInfo', 'views', ''),
    meta: {
      title: '报名信息'
    }
  },
  {
    path: '/updateEnrollUserInfo',
    name: 'updateEnrollUserInfo',
    component: loadcomponents.load('studycenter/enroll/updateEnrollUserInfo', 'views', ''),
    meta: {
      title: '修改报名信息'
    }
  },
  {
    path: '/paySuccess',
    name: 'paySuccess',
    component: loadcomponents.load('studycenter/enroll/paySuccess', 'views', ''),
    meta: {
      title: '报名成功'
    }
  },
  // 考前培训
  {
    path: '/practicaltraining',
    name: 'practicaltraining',
    component: loadcomponents.load('practicaltraining', 'views', ''),
    meta: {
      title: '考前培训'
    }
  },
  {
    path: '/trainCourseDetail',
    name: 'trainCourseDetail',
    component: loadcomponents.load('coursedetail', 'views', '/practicaltraining'),
    meta: {
      title: '考前培训'
    }
  },
  {
    path: '/trainContinue',
    name: 'trainContinue',
    component: loadcomponents.load('continue', 'views', '/practicaltraining/coursedetail'),
    meta: {
      title: '考前培训'
    }
  },
  {
    path: '/trainStartStudy',
    name: 'trainStartStudy',
    component: loadcomponents.load('start_study', 'views', '/practicaltraining/coursedetail'),
    meta: {
      title: '考前培训'
    }
  },
  {
    path: '/trainTraincase',
    name: 'trainTraincase',
    component: loadcomponents.load('traincase', 'views', '/practicaltraining'),
    meta: {
      title: '考前培训'
    }
  },
  {
    path: '/trainsTarttrain',
    name: 'trainsTarttrain',
    component: loadcomponents.load('starttrain', 'views', '/practicaltraining/traincase'),
    meta: {
      title: '考前培训'
    }
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: loadcomponents.load('statistics', 'views', ''),
    meta: {
      title: '可视化信息'
    }
  },
  {
    path: '/statistics1',
    name: 'statistics1',
    component: loadcomponents.load('statistics/statistics1', 'views', ''),
    meta: {
      title: '可视化信息'
    }
  },
  {
    path: '/checkPay',
    name: 'checkPay',
    component: loadcomponents.load('checkPay', 'views', '/studycenter/enroll'),
    meta: {
      title: '支票支付'
    }
  },
  {
    path: '/companyPay',
    name: 'companyPay',
    component: loadcomponents.load('companyPay', 'views', '/studycenter/enroll'),
    meta: {
      title: '对公转账'
    }
  },
  {
    path: '/competitiontrain',
    name: 'competitiontrain',
    component: loadcomponents.load('competitiontrain', 'views', ''),
    meta: {
      title: '赛事训练'
    }
  },
  {
    path: '/practice',
    name: 'practice',
    component: loadcomponents.load('practice', 'views', '/competitiontrain'),
    meta: {
      title: '练习模式'
    }
  },
  {
    path: '/examination',
    name: 'examination',
    component: loadcomponents.load('examination', 'views', '/competitiontrain'),
    meta: {
      title: '考试模式'
    }
  },
  {
    path: '/specialpractice',
    name: 'specialpractice',
    component: loadcomponents.load('specialpractice', 'views', '/competitiontrain'),
    meta: {
      title: '专项练习'
    }
  },
  {
    path: '/caselibrary',
    name: 'caselibrary',
    component: loadcomponents.load('caselibrary', 'views', ''),
    meta: {
      title: '案例库'
    }
  },
  {
    path: '/caselibrarydetail',
    name: 'caselibrarydetail',
    component: loadcomponents.load('caselibrarydetail', 'views', '/caselibrary'),
    meta: {
      title: '案例详情'
    }
  },
  {
    path: '/examtasks',
    name: 'examtasks',
    component: loadcomponents.load('examtasks', 'views', '/competitiontrain'),
    meta: {
      title: '考试任务'
    }
  },
  {
    path: '/examdetail',
    name: 'examdetail',
    component: loadcomponents.load('examdetail', 'views', '/competitiontrain'),
    meta: {
      title: '考试详情'
    }
  },
  {
    path: '/examrecords',
    name: 'examrecords',
    component: loadcomponents.load('examrecords', 'views', '/competitiontrain'),
    meta: {
      title: '模拟考试记录'
    }
  },
  {
    path: '/wrongpractice',
    name: 'wrongpractice',
    component: loadcomponents.load('wrongpractice', 'views', '/competitiontrain'),
    meta: {
      title: '练习模式'
    }
  },
  {
    path: '/practicedetail',
    name: 'practicedetail',
    component: loadcomponents.load('practicedetail', 'views', '/competitiontrain'),
    meta: {
      title: '练习详情'
    }
  },
  {
    path: '/custompractice',
    name: 'custompractice',
    component: loadcomponents.load('custompractice', 'views', '/competitiontrain'),
    meta: {
      // 个人中心考试任务
      title: '考试任务'
    }
  },
  {
    path: '/sampleexam',
    name: 'sampleexam',
    component: loadcomponents.load('sampleexam', 'views', '/competitiontrain'),
    meta: {
      // 个人中心考试任务
      title: '样题考试'
    }
  }

]
Vue.use(Router)
const VueRouter = new Router({
  mode: 'history',
  routes,
  catchAll: { path: '*', redirect: '/' }
})
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

VueRouter.beforeEach(function (to, from, next) {
  var token = getLocal.getCookie('token') || null
  if (to.path === '/') {
    next()
    return
  }
  if (token) {
    if (to.name === null) {
      localStorage.setItem('loginBefor', '')
    } else if (to.name === 'home') {
      localStorage.setItem('loginBefor', '')
    } else {
      localStorage.setItem('loginBefor', to.name)
    }
    if (from.name === null) {
      localStorage.setItem('loginFrom', '/')
    } else if (to.name === 'home') {
      localStorage.setItem('loginFrom', '/')
    } else {
      localStorage.setItem('loginFrom', from.name)
    }
    localStorage.setItem('loginBeforQuery', JSON.stringify(to || {}))
    next()
  } else {
    next()
  }
  // 已登录的情况再去登录页，跳转至首页
  // if (to.name === 'login') {
  //   if (token && localStorage.getItem('code') == null) {
  //     VueRouter.push({name: 'home'})
  //   }
  // }
})

export default VueRouter



// WEBPACK FOOTER //
// ./src/router/index.js